<template>
  <div class="rt-detail-header">
    <div class="header-icon"><slot name="icon" /></div>
    <div class="header-content"><slot /></div>
    <div class="header-btns"><slot name="btn" /></div>
    <rt-button
      v-if="showBack"
      class="rt-btn-back"
      icon="rt-base-back"
      @click="back"
      >返回</rt-button
    >
  </div>
</template>

<script>
import RtButton from '../../button/rtButton';
export default {
  name: 'RtDetailHeader',
  components: { RtButton },
  props: {
    showBack: {
      type: Boolean,
      default: true
    },
    autoBack: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    back() {
      if (this.autoBack) {
        this.$router.back();
        return;
      }
      this.$emit('back');
    }
  }
};
</script>

<style lang="less">
.rt-detail-header {
  display: flex;
  background: #fff;
  padding: 16px 20px 14px 20px;
  position: relative;
  z-index: 1;
  align-items: center;
  .header-icon {
    margin-right: 20px;
  }
  .header-content {
    flex: 1;
  }
  .header-btns {
    margin-right: 30px;
  }
  .rt-btn-back {
    color: #6388c2;
    border-color: #ced5ef;
    padding: 7px 15px;
    .rt-crm-icon {
      margin-top: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// rtDetailHeader.vue?9e6d6c28